import React, { useState } from 'react';

import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions } from '@mui/material';

import useGeneralDialog from 'hooks/dialogs/useGeneralDialog';

import { StyledDialogContent } from 'components/styled/Dialog/StyledDialogContent';
import { StyledDialogTitle } from 'components/styled/Dialog/StyledDialogTitle';

import { isNullOrUndefined } from 'utils/utils';

const GeneralDialog: React.FC = () => {
    const generalDialog = useGeneralDialog();

    if (isNullOrUndefined(generalDialog.dialogContent)) return null;

    const closeDialog = (): void => generalDialog.closeDialog();

    const closedWithSuccess = (): void => {
        generalDialog.dialogContent.onCloseWithSuccess();
        generalDialog.closeDialog();
    };

    const [triggerChild, setTriggerChild] = useState<boolean>(false);

    return (
        <Dialog
            open={generalDialog.open}
            onClose={closeDialog}
            maxWidth={generalDialog.dialogSize}
            fullWidth
        >
            <StyledDialogTitle>
                {generalDialog.dialogContent.title}
                <Close sx={{ cursor: 'pointer' }} onClick={closeDialog} />
            </StyledDialogTitle>
            <StyledDialogContent>
                {React.createElement(generalDialog.dialogContent.component, {
                    triggerChild: triggerChild,
                    preSetContent: generalDialog.dialogContent.preSetContent,
                    closeDialog: closedWithSuccess,
                })}
            </StyledDialogContent>
            {!generalDialog.dialogContent.hideActions && (
                <DialogActions>
                    <Button size="small" onClick={closeDialog}>
                        {generalDialog.dialogContent.closeLabel}
                    </Button>
                    <Button
                        size="small"
                        onClick={() => setTriggerChild(!triggerChild)}
                    >
                        {generalDialog.dialogContent.confirmLabel}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default GeneralDialog;
